import { GeneratorBrowser, SectionTitle } from '@sloyd/ui';
import { useKey } from 'react-use';
import { $a } from 'shared-base';
import { Wrapper } from './ContentGenerators.style';

export type ContentGeneratorsProps = {
  generators: IGenerator[];
  isLoading: boolean;
  palettes: IPalette[];
  whiteThumbnails: boolean;
  callbacks: {
    onClick: (item: IGenerator) => void;
    onAction: OnAction;
    onThumbChange: (whiteThumbnails: string) => void;
  };
};

export function ContentGenerators(props: ContentGeneratorsProps) {
  const { generators, callbacks, isLoading, whiteThumbnails, palettes } = props;

  const description = `${generators.length} items`;

  useKey('ArrowRight', (ev) => {
    ev.preventDefault();
    callbacks.onAction($a('GENERATORS', 'nextPrev', '', { delta: 1 }));
  });

  useKey('ArrowUp', (ev) => {
    ev.preventDefault();
    callbacks.onAction($a('GENERATORS', 'nextPrev', '', { delta: -1 }));
  });

  useKey('ArrowLeft', (ev) => {
    ev.preventDefault();
    callbacks.onAction($a('GENERATORS', 'nextPrev', '', { delta: -1 }));
  });

  useKey('ArrowDown', (ev) => {
    ev.preventDefault();
    callbacks.onAction($a('GENERATORS', 'nextPrev', '', { delta: 1 }));
  });

  return (
    <Wrapper className='ContentGenerators-wrapper' data-testid='ContentGenerators-wrapper'>
      <GeneratorBrowser
        whiteThumbnails={whiteThumbnails}
        onThumbChange={callbacks.onThumbChange}
        generators={generators}
        onAction={callbacks.onAction}
        isLoading={isLoading}
      >
        <SectionTitle
          gradient={{ from: '#fc4a1a', to: '#f7b733' }}
          title='⚡ Generators'
          description={description}
          compact
        />
      </GeneratorBrowser>
    </Wrapper>
  );
}

export default ContentGenerators;
